const licenseRegistry = new Map();
export function getLicenseForCertificate(certificateType) {
    const license = licenseRegistry.get(certificateType);
    if (license === undefined) {
        throw new Error('No license found with requested type');
    }
    return license;
}
export function registerLicense(license, certificateType) {
    Object.freeze(license);
    licenseRegistry.set(certificateType, license);
}
//# sourceMappingURL=LicenseRegistry.js.map